import { render, staticRenderFns } from "./Msg.vue?vue&type=template&id=16a7dbd2&"
import script from "./Msg.vue?vue&type=script&lang=ts&"
export * from "./Msg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports